import type { PropsWithChildren } from "react"
import { useAuth } from "react-oidc-context"
import { useT } from "../lib/i18n"

export function ProtectedRoute({ children }: PropsWithChildren) {
  const auth = useAuth()
  const { t } = useT()

  if (auth.isLoading) return <FullPage>{t("loading")}</FullPage>
  if (auth.error) return <FullPage>{t("auth_error")}: {auth.error.message}</FullPage>
  if (!auth.isAuthenticated) {
    void auth.signinRedirect()
    return <FullPage>{t("redirecting_signin")}</FullPage>
  }
  return <>{children}</>
}

function FullPage({ children }: PropsWithChildren) {
  return (
    <main style={{
      display: "grid", placeItems: "center", height: "100dvh",
      color: "var(--muted)", fontFamily: "var(--font)",
    }}>
      {children}
    </main>
  )
}
